<template>
    <div class="flex">
        <div clas="pl-2">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn small text icon v-bind="attrs" v-on="on" class="gridbutton">
                        <v-icon medium color="blue">mdi-information-variant</v-icon>
                    </v-btn>                
                </template>
                <span>
                    <div>
                        Mail will be sent to: 
                    </div>
                    <div v-if="hocts.length !== 0">
                        <tr v-for="(contact, index) in hocts" :key="index">
                            <td class="pr-3">{{ contact.role }}</td>
                            <td class="pr-3">{{ contact.name }}</td>
                            <td class="pr-3">{{ contact.email }}</td>                    
                            <td>{{ contact.taalcode }}</td> 
                        </tr>
                    </div>
                    <div v-else>
                        (no recipients)
                    </div>
                </span>
            </v-tooltip> 
        </div> 
    </div>
</template>

<script>

export default {
    watch:{
        hpbz_encrid: {            
            handler(){
                this.getHoctRecords();
            } 
        },
    },        
    props: {
        hpbz_encrid: {
            type: String,
            default: ''
        },      
    },             
    data() {
        return {
            hocts: [],
        }
    },
    methods: {  
        getHoctRecords() {
            this.$axios
                .post("ares/json/ares/hpbz/getHpbzHoct.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHpbzHoct"
                    },
                    getHpbzHoct: {
                        hpbz_encrid: this.hpbz_encrid
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error.message);
                    } else {
                        this.hocts = res.data.getHpbzHoct;
                    }
                })
        },        
    }
}
</script>

<style scoped>
.flex{
    display: flex;
    flex-direction: row;
}
.gridbutton:hover{
    border: 1px solid rgba(169, 169, 169, 1) !important;
}
</style>